import React, { useEffect, useRef, useState } from "react";
import vertexLogoLottie from "assets/logo/vertex-logo-lottie.json";
import { loadLottieWebFromCdn } from "pages/Rostering/UpdatedTimeSheet/TimeSheetDetailsSection/ai/utils/loadLottieWebFromCdn";

/**
 * Vertex logo Lottie for the floating Copilot FAB (CDN lottie-web, no npm package).
 * @param {{ size?: number, playing?: boolean }} props
 */
const Vertex360CopilotFloatingLottie = ({ size = 40, playing = true }) => {
  const containerRef = useRef(null);
  const animRef = useRef(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return undefined;

    let cancelled = false;
    node.innerHTML = "";
    setFailed(false);

    loadLottieWebFromCdn()
      .then((lottie) => {
        if (cancelled || !containerRef.current) return;

        animRef.current = lottie.loadAnimation({
          container: containerRef.current,
          renderer: "svg",
          loop: true,
          autoplay: true,
          animationData: vertexLogoLottie,
        });

        if (!playing) {
          animRef.current.pause();
        }
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });

    return () => {
      cancelled = true;
      animRef.current?.destroy();
      animRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (!animRef.current) return;
    if (playing) {
      animRef.current.play();
    } else {
      animRef.current.pause();
    }
  }, [playing]);

  if (failed) {
    return (
      <span
        className="copilot-floating-lottie__fallback"
        style={{ width: size, height: size }}
        aria-hidden
      >
        V360
      </span>
    );
  }

  return (
    <div
      ref={containerRef}
      className="copilot-floating-lottie"
      style={{ width: size, height: size * 0.72, maxWidth: "100%", maxHeight: "100%" }}
      aria-hidden
    />
  );
};

export default Vertex360CopilotFloatingLottie;
